module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/wedding_planning_book-4311ee808cd87298413c55755008a6fa.svg";